"use client";

import { useEffect, useState } from "react";
import "./CaseStudies.css";

interface CaseStudy {
  id: string;
  image: string;
  heading: string;
  subheading: string;
  href: string;
}

function ArrowUpRight() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M7 17 17 7M8 7h9v9" />
    </svg>
  );
}

/* Saari styling CaseStudies.css me hai. Class names unique (csd-*) hain, taaki
   purani CaseStudies.css ya kisi global CSS ke .case-study-card* rules se clash na ho. */
export default function CaseStudies() {
  const [caseStudies, setCaseStudies] = useState<CaseStudy[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCaseStudies = async () => {
      try {
        // sirf active case studies + halki image URLs (base64 nahi)
        const response = await fetch("/api/case-studies/public", {
          method: "GET",
          cache: "no-store",
        });

        const result = await response.json();

        if (result.success) {
          setCaseStudies(result.data);
        }
      } catch (error) {
        console.error("Failed to fetch case studies:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCaseStudies();
  }, []);

  if (loading) {
    return null;
  }

  return (
    <section className="csd-section">
      <div className="csd-container">
        <div className="csd-head">
          <span className="csd-eyebrow">Our Work</span>
          <h1 className="csd-title">Case Studies</h1>
        </div>

        {caseStudies.length === 0 ? (
          <p className="csd-empty">No case studies available yet.</p>
        ) : (
          <div className="csd-grid">
            {caseStudies.map((study) => (
              <a
                className="csd-card"
                key={study.id}
                href={study.href}
                aria-label={`View ${study.heading}`}
              >
                <div className="csd-media-wrap">
                  <div className="csd-media">
                    <img src={study.image} alt={study.heading} className="csd-image" loading="lazy" />
                  </div>
                  <span className="csd-arrow" aria-hidden="true">
                    <ArrowUpRight />
                  </span>
                </div>

                <div className="csd-body">
                  <h2>{study.heading}</h2>
                  <p>{study.subheading}</p>
                </div>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}